import { RawTextInput } from '@festina-life/ui/forms'
import { Icon } from '@festina-life/ui/structure'
import { type ReactNode, useState } from 'react'

import { EditorButtonGroup } from '../editorButtonGroup/EditorButtonGroup'
import { HoverEditButton } from '../hoverEditGroup/HoverEditButton'

type Props = {
  initialValue: string
  onSave: (nextValue: string) => void | Promise<void>
  externalActions?: ReactNode
}

export const InlineTextEditor = ({
  initialValue,
  onSave,
  externalActions,
}: Props) => {
  const [isEditing, setIsEditing] = useState(false)
  const [currentValue, setCurrentValue] = useState(initialValue)

  const handleCancel = () => {
    setIsEditing(false)
    setCurrentValue(initialValue)
  }

  const handleSaveValue = async () => {
    setIsEditing(false)
    await onSave(currentValue)
  }

  return isEditing ? (
    <div className="w-full">
      <RawTextInput
        value={currentValue}
        onChange={(event) => setCurrentValue(event.target.value)}
      />
      <EditorButtonGroup
        className="relative! mt-1"
        onCancel={handleCancel}
        onSave={handleSaveValue}
      />
    </div>
  ) : (
    <>
      <div className="grow">{initialValue}</div>
      {externalActions ?? (
        <HoverEditButton
          className="invisible absolute right-2 top-2 group-hover:visible"
          icon={<Icon name="Pencil" />}
          onClick={() => setIsEditing(true)}
        />
      )}
    </>
  )
}
